import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import styled from 'styled-components';
import SharingIcons from '../molecules/SharingIcons';
import CopyLink from '../molecules/CopyLink';
import { sharing } from '../data/sharing';

const Holder = styled.main`
  ol {
    list-style: none;
    counter-reset: ttc;
    padding-left: 0;
    > li::before {
      content: counter(ttc);
      font-weight: bold;
      color: ${props => props.theme.colours.link};
      font-size: 4rem;
      line-height: 1;
      margin-right: 2rem;
    }
    > li {
      counter-increment: ttc;
      display: flex;
      margin-bottom: 1.5rem;
      > p { margin: 0; }
    }
  }
  .again {
    margin-top: 4rem;
  }
`;

class ThankYou extends Component {

  render() {
    return (
      <Holder>

        <h1>Wrap up</h1>
        <p>We hope you enjoyed learning more about machine learning bias.</p>
        <p>In this exercise we learned that:</p>
        <ol>
          <li><p>It’s important to have a diverse set of <strong>people</strong> building machine learning</p></li>
          <li><p>It’s important to have a diverse set of <strong>images</strong> when training machine learning</p></li>
          <li><p>It’s important to have a diverse set of <strong>labels</strong> available when training machine learning</p></li>
        </ol>
        <p>But even with a diverse set of people, images and labels, there is still the possibility that different people choose different labels. As we have seen in this exercise, we all have different biases and perceive the world in diverse ways. Because of that, there is still another thing you need: a process ensuring the consistent selection of labels, through guidelines or instructions. Otherwise, the avatars can still vary dramatically based on who is doing the labeling.</p>

        <SharingIcons 
          shareURL = {sharing.home.ogUrl}
          shareTitle = {sharing.home.ogTitle} 
          shareDesc = {sharing.home.ogDesc} 
        />
        <CopyLink />

        <h5 className="again">Want to do the exercise again?</h5>
        <Link className="button primary" to="/">Start again </Link>
      </Holder>
    )
  }
}

export default withRouter( ThankYou );
